import { Slot } from "@radix-ui/react-slot";
import classNames from "classnames/bind";
import React, { forwardRef, isValidElement, PropsWithChildren } from "react";
import styles from "./Skeleton.module.scss";
import type { SkeletonProps } from "./types";

const cx = classNames.bind(styles);

/**
 * Indicates a loading state by replacing it's content with a placeholder of the same shape
 */
export const Skeleton = forwardRef<React.ElementRef<"div">, SkeletonProps>(
  (
    {
      children,
      isLoading,
      className,
      isBusy = true,
      ...props
    }: PropsWithChildren<SkeletonProps>,
    forwardedRef
  ) => {
    if (!isLoading) return <>{children}</>;

    const CustomNode = isValidElement(children) ? Slot : "div";

    return (
      <CustomNode
        ref={forwardedRef}
        aria-hidden
        className={cx("skeleton", { isBusy }, className)}
        data-is-inline={isValidElement(children) ? undefined : true}
        tabIndex={-1}
        {...props}
      >
        {children}
      </CustomNode>
    );
  }
);

Skeleton.displayName = "Skeleton";
